export const toLovelace = (val: number, decimals: number) =>
  Math.floor(val * Math.pow(10, decimals));
export const fromLovelace = (val: number, decimals: number) =>
  Math.floor(val / Math.pow(10, decimals));
